module.exports = __webpack_public_path__ + "static/41-Freewheel-5470f53de326ad0ef2dd09953ca745cb.png";